import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "@/services/auth";
import toast from "react-hot-toast";

export default function LogoutPage() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogout = async () => {
            const success = await logout();
            setLoading(false);

            if (success) {
                toast.success("Anda berhasil logout");
                navigate("/login", { replace: true });
            } else {
                toast.error("Gagal logout, silakan coba lagi");
            }
        };

        handleLogout();
    }, [navigate]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 text-center px-6">
            <div className="flex flex-col items-center gap-3">
                <div className="h-10 w-10 border-4 border-t-transparent border-indigo-500 rounded-full animate-spin"></div>
                <h2 className="text-lg font-medium text-gray-700 dark:text-gray-200">
                    {loading ? "Sedang logout..." : "Mengalihkan ke halaman login..."}
                </h2>
            </div>
        </div>
    );
}
